/*
  USVAR-001A - US market: normalize variant selection so sold-out variants are never selected/priced.
  Server-side Liquid already (a) skips rendering sold-out option values for US buyers,
  (b) prices/exposes the first available variant, (c) submits an available Add-to-Cart id.
  This module only fixes the client state for US buyers when a deep link points at a sold-out
  variant (its option value was not rendered, so no radio is checked): it selects the first
  available (rendered) option value and lets the theme's own change pipeline update price / media /
  Add to Cart / URL / sticky bar. US is detected from Shopify localization (data-us-market),
  never from hostname / IP / cookie / hardcoded id; no product, SKU or variant id is hardcoded, so
  restocked sizes reappear automatically via the server render.
*/
(function () {
  function isUS(vs) { return (vs.getAttribute('data-us-market') || '').toUpperCase() === 'US'; }

  function normalize(vs) {
    if (!isUS(vs)) return;
    vs.querySelectorAll('fieldset').forEach(function (fs) {
      var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;
      var checked = inputs.filter(function (i) { return i.checked; })[0];
      if (checked) return; // valid server selection (sold-out values are not rendered for US)
      var firstAvailable = inputs.filter(function (i) { return !i.classList.contains('disabled'); })[0];
      if (!firstAvailable) return; // whole option sold out -> keep product-level sold-out state
      firstAvailable.checked = true;
      firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
    });
    vs.querySelectorAll('select').forEach(function (sel) {
      var opts = Array.prototype.slice.call(sel.options);
      if (!opts.length) return;
      var sel0 = opts.filter(function (o) { return o.selected && !o.classList.contains('disabled'); })[0];
      if (sel0) return;
      var firstAvailable = opts.filter(function (o) { return !o.classList.contains('disabled'); })[0];
      if (!firstAvailable) return;
      sel.value = firstAvailable.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function run() { document.querySelectorAll('variant-selects').forEach(normalize); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
